import { useCallback } from 'react';
import { TextField, Tooltip} from '@mui/material';

import { useStepValidator } from 'Hooks/useStepValidator';
import { INPUT_STEP_NAMES } from 'Pages/Inputs/constants';
import { useInputStore } from 'Store';

// TODO: input doesn't allow you to enter decimal point if it is empty

export const DigestEnergy = () => {
  const digest_energy = useInputStore(state => state.digest_energy)
  const setValue = useInputStore((state) => state.set_value)

  // validation
  // TODO: should there be a max number?
  const isValidNumber = useCallback(() => {
    const number = Number(digest_energy)

    // is it a valid number
    if (isNaN(number)) return false
    
    // is it a positive number
    return number >= 0
  }, [digest_energy])

  useStepValidator(INPUT_STEP_NAMES.numbers, 'digest_energy', () => isValidNumber(digest_energy))
  
  return (
    <Tooltip title='Ratio of digest energy to total energy of feed'>
      <TextField
        size='small'
        type='number' 
        label='Digestible Energy'
        value={digest_energy}
        onChange={event => setValue({'digest_energy': parseFloat(event.target.value)})}
        error={!isValidNumber()}
        helperText={!isValidNumber() ? 'Please enter a valid number. This cannot be less than 0.' : ''}
      />
    </Tooltip>
  )
}

